import template from './opportunitiesPanels.html';
import controller from './opportunitiesPanels.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
  }
};

export default component;
